<template>
	<section
		class="about-crowdedhero"
		:class="{ 'has-bgimage': backgroundImage }"
		:style="
			backgroundImage
				? `--backgroundImage: url(${backgroundImage}); --mobileBackgroundImage: url(${
						mobileBackgroundImage || backgroundImage
				  })`
				: ''
		"
	>
		<!-- opcionális dekor/overlay -->
		<div class="bg-overlay"></div>

		<div class="container">
			<div class="content">
				<!-- LEFT -->
				<div class="left">
					<h1 class="title headline-l">
						{{ $t('crowdxScreen.aboutHero.title') }}
					</h1>

					<div
						class="paragraph text-l bold"
						v-html="$t('crowdxScreen.aboutHero.p1')"
					></div>
					<div
						class="paragraph text-l"
						v-html="$t('crowdxScreen.aboutHero.p2')"
					></div>
					<div
						class="paragraph text-l bold"
						v-html="$t('crowdxScreen.aboutHero.p3')"
					></div>

					<div class="cta">
						<base-button
							class="about-button"
							:text="$t('crowdxScreen.aboutHero.button')"
							size="large"
							type="light"
							@clicked="handleButtonClick"
						/>
					</div>
				</div>

				<!-- RIGHT -->
				<div class="right">
					<div class="image-wrap">
						<img
							class="person-image"
							:src="rightImage"
							:alt="rightImageAlt || 'Portrait'"
							loading="lazy"
						/>

						<!-- 						<div class="name-plate">
							<div class="name">
								{{ $t('crowdxScreen.aboutHero.nameLabel') }}
							</div>
							<div class="role">
								{{ $t('crowdxScreen.aboutHero.roleLabel') }}
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'AboutCrowdedHero',
	props: {
		backgroundImage: {
			type: String,
			required: false,
			default: '/images/sections/crowdx/about-hero-bg.png',
		},
		mobileBackgroundImage: {
			type: String,
			required: false,
		},

		rightImage: {
			type: String,
			required: false,
			default: '/images/sections/crowdx/hero.png',
		},
		rightImageAlt: {
			type: String,
			required: false,
			default: 'CEO portrait',
		},

		buttonUrl: {
			type: String,
			required: false,
			default: 'https://crowdedhero.com/',
		},
	},
	methods: {
		handleButtonClick() {
			window.open(this.buttonUrl, '_blank');
		},
	},
};
</script>

<style lang="scss">
.about-crowdedhero {
	position: relative;
	overflow: hidden;

	background: linear-gradient(99.29deg, #ce2328 5.54%, #ed8532 94.06%);
	padding: 80px 0;

	@media (max-width: $breakpoint-lg) {
		padding: 70px 0;
	}

	@media (max-width: $breakpoint-sm) {
		padding: 60px 0;
	}

	&.has-bgimage {
		background-image: var(--backgroundImage);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;

		@media (max-width: $breakpoint-sm) {
			background-image: var(--mobileBackgroundImage);
		}
	}

	.bg-overlay {
		position: absolute;
		inset: 0;
		background: linear-gradient(
			90deg,
			rgba(0, 0, 0, 0.25) 0%,
			rgba(0, 0, 0, 0.1) 55%,
			rgba(0, 0, 0, 0) 100%
		);
		pointer-events: none;
		z-index: 0;
	}

	.container {
		position: relative;
		z-index: 1;
	}

	.content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 60px;

		@media (max-width: $breakpoint-lg) {
			gap: 40px;
		}

		@media (max-width: $breakpoint-md) {
			flex-direction: column;
			align-items: stretch;
			gap: 40px;
		}
	}

	.left {
		flex: 1 1 58%;
		min-width: 0;
		color: #fff;

		@media (max-width: $breakpoint-md) {
			flex: 1 1 auto;
			text-align: center;
		}
	}

	.title {
		color: #fff;
		text-transform: uppercase;
		margin: 0 0 34px 0;

		@media (max-width: $breakpoint-sm) {
			margin-bottom: 20px;
		}
	}

	.paragraph {
		color: #ffffff;
		line-height: 24px;
		max-width: 635px;
		font-size: 16px;

		& + .paragraph {
			margin-top: 18px;
		}

		@media (max-width: $breakpoint-md) {
			margin-left: auto;
			margin-right: auto;
		}

		@media (max-width: $breakpoint-sm) {
			font-size: 16px;
			line-height: 22px;
		}
	}

	.cta {
		margin-top: 69px;

		@media (max-width: $breakpoint-md) {
			display: flex;
			justify-content: center;
            margin-top: 25px;
		}

		.about-button {
			min-width: 220px;
			text-transform: none;
			@media (max-width: $breakpoint-sm) {
				width: 100%;
				min-width: 0;
			}
		}
	}

	.right {
		flex: 0 0 42%;
		display: flex;
		justify-content: flex-end;
		min-width: 0;

		@media (max-width: $breakpoint-md) {
			justify-content: center;
		}
	}

	.image-wrap {
		position: relative;
		width: min(391px, 100%);
		display: flex;
		align-items: flex-end;
		justify-content: center;
		overflow: hidden;

		box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.18);
	}

	.person-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center top;
		display: block;
	}

	.name-plate {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;

		padding: 10px 0px 4px 0px;
		background: linear-gradient(180deg, #3d3551 0%, #c9f2ff00 100%);
		opacity: 0.85;
		backdrop-filter: blur(2px);

		text-align: center;
		color: #fff;
		text-transform: uppercase;
		line-height: 22px;

		.name {
			font-family: 'HKNova-Bold', sans-serif;
			font-size: 18px;
		}

		.role {
			margin-top: 6px;
			font-family: 'HKNova-Bold', sans-serif;
		}

		@media (max-width: $breakpoint-sm) {
			padding: 14px 14px 12px 14px;

			.name {
				font-size: 16px;
			}
			.role {
				font-size: 13px;
			}
		}
	}
}

.bold {
	font-family: 'HKNova-Bold', sans-serif;
	font-weight: bold;
}
</style>
